import { InjectionToken } from '@angular/core';

export const EDR_BASE_URL = new InjectionToken<string>('EDR_BASE_URL');
